<template>
  <div class="channel-page">
    <!-- 公共头部 -->
    <AppHeader />

    <!-- 轮播图 -->
    <ChannelBannerCarousel
      v-if="bannerItems.length > 0"
      :items="bannerItems"
      class="channel-page__banner"
    />

    <!-- 新闻列表 -->
    <ChannelNewsList
      :items="newsItems"
      :loading="newsLoading"
      :finished="newsFinished"
      class="channel-page__news-list"
      @load-more="loadMoreNews"
      @item-click="onNewsClick"
    />
  </div>
</template>

<script>
import AppHeader from '../home/components/AppHeader.vue'
import ChannelBannerCarousel from './components/BannerCarousel.vue'
import ChannelNewsList from './components/NewsList.vue'
import { getNewsListL2 } from '../../api/news'

export default {
  name: 'ChannelPage',
  components: {
    AppHeader,
    ChannelBannerCarousel,
    ChannelNewsList
  },
  data() {
    return {
      /* ── 头部数据 ── */

      /* ── 轮播图数据 ── */
      bannerItems: [],
      bannerNewsIds: [],

      /* ── 新闻列表数据 ── */
      newsItems: [],
      newsLoading: false,
      newsFinished: false,
      newsPageNum: 1,
      newsPageSize: 10
    }
  },
  computed: {
    categoryId() {
      // 支持 /channel/index?categoryId=xxx 和 /channel/:categoryId
      const queryId = this.$route.query && this.$route.query.categoryId
      const paramId = this.$route.params && this.$route.params.categoryId
      return Number(queryId) || Number(paramId) || 1
    }
  },
  created() {
    this.loadBanner()
    this.loadNews()
  },
  watch: {
    categoryId(newId, oldId) {
      if (newId && newId !== oldId) {
        this.loadBanner()
        this.loadNews()
      }
    }
  },
  methods: {
    async loadBanner() {
      try {
        const res = await getNewsListL2({
          categoryId: this.categoryId,
          isRecommended: 1,
          pageSize: 6,
          pageNum: 1
        })
        const data = res.data || {}
        const rows = data.rows || data.list || data.records || []
        this.bannerNewsIds = rows.map(item => item.newsId || item.id).filter(Boolean)
        this.bannerItems = rows.map(item => this.formatNewsItem(item))
      } catch (err) {
        console.error('轮播图加载失败:', err)
        this.bannerItems = []
        this.bannerNewsIds = []
      }
    },
    async loadNews(isLoadMore = false) {
      if (this.newsLoading) return
      this.newsLoading = true
      if (!isLoadMore) {
        this.newsPageNum = 1
        this.newsFinished = false
      }
      try {
        const res = await getNewsListL2({
          categoryId: this.categoryId,
          isRecommended: 0,
          pageNum: this.newsPageNum,
          pageSize: this.newsPageSize,
          excludeNewsIdList: this.bannerNewsIds
        })
        const data = res.data || {}
        const rows = data.rows || data.list || data.records || []
        const list = rows.map(item => this.formatNewsItem(item))
        if (isLoadMore) {
          this.newsItems = this.newsItems.concat(list)
        } else {
          this.newsItems = list
        }
        if (list.length < this.newsPageSize) {
          this.newsFinished = true
        }
      } catch (err) {
        console.error('新闻列表加载失败:', err)
      } finally {
        this.newsLoading = false
      }
    },
    loadMoreNews() {
      if (this.newsFinished || this.newsLoading) return
      this.newsPageNum += 1
      this.loadNews(true)
    },
    formatNewsItem(item) {
      return {
        id: item.id,
        newsCode: item.newsCode,
        title: item.title || '',
        source: item.source || item.sourceName || '',
        time: item.publishTime || item.createTime || '',
        thumbnail: item.coverImage || item.thumbnail || item.image || ''
      }
    },
    onNewsClick(item) {
      if (!item.newsCode && !item.id) return
      this.$router.push(`/detail?newsCode=${item.newsCode || item.id}`)
    }
  }
}
</script>

<style scoped>
/* ── 引入设计令牌 ── */
@import '../home/assets/_variables.css';

/* ── 页面容器 ── */
.channel-page {
  background-color: var(--color-white);
  position: relative;
  width: var(--page-width);
  height: auto;
  overflow: hidden;
  padding-bottom: 40px;
}

.channel-page__banner {
  margin-top: 20px;
}

.channel-page__news-list {
  margin: 28px 0 0 var(--space-6);
}
</style>
